module.exports = __webpack_public_path__ + "static/img/UTSG教室_1.04ddcb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSG/UTSG教室_1.png
// module id = qiRB
// module chunks = 0